import { render, staticRenderFns } from "./PromotionType.vue?vue&type=template&id=ec91a616&scoped=true"
import script from "./PromotionType.vue?vue&type=script&lang=js"
export * from "./PromotionType.vue?vue&type=script&lang=js"
import style0 from "./PromotionType.vue?vue&type=style&index=0&id=ec91a616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec91a616",
  null
  
)

export default component.exports